
import React, { Component } from 'react';
import { Layout } from 'antd';
import RouteView from './route';
import Header from './header';
import Menu from './menu';
import Footer from './footer';
import { Navigate } from 'react-router-dom';

export default class UserLayout extends Component {
    render() {
        const token = sessionStorage.getItem('token');

        if (!token) {
            return <Navigate to="/login" replace />;
        }

        return (
            <>
                <Layout style={{ minHeight: '100vh' }}>
                    <Header />

                    <Layout hasSider className='container-display-center'>

                        <Layout.Sider theme="light">
                            <div style={{ flexGrow: 2 }}>
                                <Menu mode="inline" />
                            </div>
                        </Layout.Sider>

                        <Layout.Content>
                            <div
                                className='m-l-sm p-lg'
                                style={{ background: '#fff', minHeight: '100%' }}
                            >
                                <RouteView />
                            </div>
                        </Layout.Content>

                    </Layout>

                    <Footer />
                </Layout>
            </>
        );
    }
}